window.UTILS = window.UTILS || { };

window.UTILS.initMegaMenu = function() {
	var $ = window.jQuery;

  // MegaMenu selector
  var megaMenuSelector = ".js--megamenu";
  
  // Class for MegaMenu parent (should be the same element as .dropdown)
  var megaMenuParentClass = ".dropdown--mega";

  var megaMenus = $( megaMenuSelector );

  $.each( megaMenus, function( i, el ) {
    var megaMenu = $( el );

    var activateSubmenu = function( row ) {
      var activatedItem = $( row );
      activatedItem.siblings( ".js--megamenu-item" ).removeClass( "nav-item--open" );
      activatedItem.addClass( "nav-item--open" );
    };

    var deactivateSubmenu = function( row ) {
      $( row ).removeClass( "nav-item--open" );
    };

    megaMenu.menuAim( {
      activate: activateSubmenu,
      deactivate: deactivateSubmenu,
      rowSelector: ".js--megamenu-item",
      submenuSelector: "*",
      submenuDirection: "right"
    } );

    // Show the first submenu when opening megamenu
    var megaMenuParent = megaMenu.closest( megaMenuParentClass );

    megaMenuParent.on( "show.bs.dropdown", function ( e ) {
      var megaMenuItems = $( e.currentTarget ).find( ".js--megamenu-item" );
      megaMenuItems.removeClass( "nav-item--open" );
      $( megaMenuItems.get(0) ).addClass( "nav-item--open" );

      // move megamenu towards left if it overflows right edge of viewport
      // but only if megamenu is NOT fullwidth 
      if( $( this ).css( "position" ) !== "static" ) {
        var megaMenu = $( e.currentTarget ).find( ".js--megamenu-container" );
        var overflow = $( window ).width() - ( $( this ).offset().left + megaMenu.width() );
        megaMenu.css( "left", ( Math.min( 0, overflow ) ) + "px" );
      }
    });

  } );

};

window.UTILS.initMegaMenu();